import axios from 'axios';
import router from '../router';
import store from '../store';

var host = window.location.host;
var portLocation = host.indexOf(":");
host = host.substring(0, portLocation == -1 ? undefined : portLocation);

var parts = host.split(".");

// Verwijder specifiek "dashboard" als subdomein, ongeacht de positie
parts = parts.filter(part => part !== "dashboard");

host = parts.join(".");

// Voeg de poort terug toe als die aanwezig was
if (portLocation !== -1) {
    host += window.location.host.substring(portLocation);
}

axios.defaults.baseURL = `${window.location.protocol}//${host}/`;

axios.defaults.withCredentials = true;
axios.defaults.headers.get['Pragma'] = 'no-cache';
axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store';

axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (error.response.status === 401) {
        router.push('/');
        store.dispatch('setLoggedOut');
    }
    return Promise.reject(error);
});
